export default __webpack_public_path__ + "static/two-57fdac025ac763b2693b2e88113bed25.png";